const routesHidden = ['/dashboard', '/no-access'];

export default routesHidden;

export const hideSourceFilterRoutes = ['/performances'];
